import { Container } from "reactstrap";
import PlansMenu from "../components/Sidebar/PlansMenu";
import MainLayout from "./MainLayout";

function PlansLayout({ children }) {  

  return(
    <MainLayout>
      <main>
        <PlansMenu />

        <Container className="py-4">
          {children}
        </Container>
      </main>
    </MainLayout>
  );
}

export default PlansLayout;